/*
 * Copyright (c) 2016-present, Parse, LLC
 * All rights reserved.
 *
 * This source code is licensed under the license found in the LICENSE file in
 * the root directory of this source tree.
 */
import Button       from 'components/Button/Button.react';
import Icon         from 'components/Icon/Icon.react';
import PropTypes    from 'prop-types';
import React        from 'react';
import styles       from 'components/EmptyState/EmptyState.scss';
import stylesButton from 'components/Button/Button.scss';
import { center }   from 'stylesheets/base.scss';

let ctaButton = (cta, ctaColor, action) => {
  if (cta) {
    if (action.constructor === String) {
      return (
        <a href={action} className={[stylesButton.button, stylesButton.primary].join(' ')} target='_blank' rel='noreferrer noopener'>
          {cta}
        </a>
      );
    } else {
      return (
       <Button
        value={cta}
        color={ctaColor ? ctaColor : 'green'}
        primary={true}
        onClick={action} />
      );
    }
  } else {
    return null;
  }
}

export default class EmptyState extends React.Component {
  constructor() {
    super();
  }

  render() {
    return (
      <div className={[styles.empty, this.props.parentScroll ? styles.parentScroll : null].join(' ')}>
        {
          this.props.children
            ?
              <div style={this.props.maxWidth ? { maxWidth: `${this.props.maxWidth}px` } : {}}>
                {this.props.children}
              </div>
            :
              <div style={this.props.maxWidth ? { maxWidth: `${this.props.maxWidth}px` } : {}}>
                <div className={[styles.title, this.props.smallTitle ? styles.smallTitle : null].join(' ')}>{this.props.title}</div>
                {
                  this.props.descriptionWithHTML
                    ? <div className={styles.description} dangerouslySetInnerHTML={{ __html: this.props.descriptionWithHTML }} />
                    : <div className={styles.description}>{this.props.description}</div>
                }
                {ctaButton(this.props.cta, this.props.ctaColor, this.props.action)}
              </div>
        }
      </div>
    );
  }
}

